import { dayjs, formatTitleForUrl, transformIpfs } from "utils";

import { Content } from "@/src/features/api/openData";
import Image from "next/image";
import { ShellLink } from "@/src/components";
import { ROUTER_PATH } from "@/src/config";
import { buildLocale } from "@/src/utils/buildLocale";

export const DocsCard: React.FC<{
  locale: string;
  category: string;
  news: Content;
  onClick?: (news: Content) => void;
  deviceType: "mobile" | "desktop" | "tablet";
}> = ({ news, locale, category: _category, deviceType }) => {
  const urlPrefix = buildLocale(locale);
  // const type = category === "crypto" ? "crypto" : "stock";
  // 按 PRD：详情页路由为 `news/channel/[title]`，本期 channel 为前端静态写死段
  const detailUrl = `${urlPrefix}${ROUTER_PATH.NEWS_TITLE_DETAIL}/${formatTitleForUrl(news?.source_link || "")}`;

  return (
    <ShellLink
      aria-label={news.title}
      data-openreplay-label={`Link | ${detailUrl}`}
      id="lnk-docs-card"
      href={detailUrl}
      className={`group w-full overflow-hidden cursor-pointer rounded-3 overflow-hidden ${deviceType !== "mobile" ? "max-h-[245px]" : "max-h-[189px]"}`}
      // onMouseEnter={(e) => {
      //   e.currentTarget.style.transform = "translateY(-2px)";
      //   e.currentTarget.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.15)";
      // }}
      // onMouseLeave={(e) => {
      //   e.currentTarget.style.transform = "translateY(0)";
      //   e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
      // }}
    >
      <div className="relative w-full rounded-3 overflow-hidden">
        <Image
          src={transformIpfs(news?.medias?.[0]?.url || "")}
          alt={news.title || ""}
          width={deviceType !== "mobile" ? 252 : 361}
          height={deviceType !== "mobile" ? 141 : 97}
          className={`w-full object-cover rounded-3 overflow-hidden ${deviceType !== "mobile" ? "transition-transform duration-300 ease-out group-hover:scale-[1.2] h-[141px] max-h-[141px] object-cover" : "h-[97px] max-h-[97px] object-center"}`}
        />
      </div>

      {/* 标题 */}
      <h3
        aria-label="Docs Card h3"
        data-openreplay-label="Docs Card h3 Semantic"
        id="sem-docs-card-h3"
        className={`body_medium_m text-content_primary max-h-[72px] mt-3 overflow-hidden transition-colors duration-200 group-hover:text-content_secondary line-clamp-3`}
      >
        {news.title}
      </h3>

      {/* 来源和时间 */}
      <span className="body_s text-content_tertiary mt-1">
        {dayjs(news.issue_date).format("MMM DD YYYY, HH:mm")}
      </span>
    </ShellLink>
  );
};
